<template>
  <v-card class="rounded-lg flex d-flex flex-column">
    <v-card-title>
      <span class="font-weight-bold text-subtitle-1 text--disabled"
        >Cepario Producción</span
      >
    </v-card-title>
    <v-card-text>
      <v-row v-if="user.role == 'CEPARIUM'">
        <v-col cols="12" xl="6" lg="6">
          <v-btn rounded color="primary" small block @click="addStrain">
            Agregar cepa
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6">
          <v-btn
            rounded
            color="primary"
            small
            block
            @click="showAddStrainIdentificatiònModalVue = true"
          >
            <v-icon> mdi-database-plus </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6">
          <v-btn
            rounded
            color="primary"
            small
            block
            @click="showHistoryRequest = true"
          >
            <v-icon> mdi-history </v-icon>
            Historial
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="10">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            label="Buscar..."
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col lg="2" md="3" sm="4">
          <v-btn small color="primary" @click="fetchData" block rounded
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </v-col>
        <v-col>
          <v-menu
            offset-y
            :close-on-click="false"
            :close-on-content-click="false"
            v-model="menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" block>
                <v-icon left>mdi-filter</v-icon>
                Filtro
              </v-btn>
            </template>
            <v-card width="350px">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        label="Peticiones"
                        :items="requestItems"
                        hide-details
                        v-model="request"
                        item-text="text"
                        clearable
                        hide-no-data
                        return-object
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        label="Almacén"
                        :items="stocktItems"
                        hide-details
                        v-model="stock"
                        item-text="text"
                        clearable
                        hide-no-data
                        return-object
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" @click="clearFilter">Restaurar</v-btn>
                <v-btn color="primary" @click="applyFilter">Aplicar</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            fixed-header
            height="450px"
            :headers="headers"
            :items="bioactives"
            :items-per-page="40"
            no-data-text="No hay microorganismos"
            loading-text="Cargando microorganismos..."
            :page.sync="page"
            hide-default-footer
            :loading="fetchingData"
            @click:row="rowSelect"
            :item-class="row_classes"
          >
            <template #[`item.identificationName`]="{ item }">
              <span
                class="text-caption primary--text"
                @click="user.role == 'CEPARIUM'?updateStrain(item):null"
                >{{ item.identificationName }}</span
              >
            </template>
            <template #[`item.strain_id`]="{ item }">
              <span class="text-caption">{{ item.strain_id }}</span>
            </template>
            <template #[`item.moType`]="{ item }">
              <span class="text-caption">{{ getTypeMO(item.moType) }}</span>
            </template>
            <template #[`item.stock`]="{ item }">
              <span class="text-caption">{{ item.stock }}</span>
            </template>
            <template #[`item.request`]="{ item }">
              <span class="text-caption">{{ item.request }}</span>
            </template>
            <template #[`item.sequenceId`]="{ item }">
              <span class="text-caption" v-if="item.sequenceId">{{
                item.sequenceId
              }}</span>
              <span class="text-caption" v-else> - </span>
            </template>
          </v-data-table>
          <v-pagination
            v-model="page"
            :length="numPages"
            total-visible="10"
            color="primary"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>
    <AddStrainModalVue
      v-if="showAddStrainModalVue"
      v-model="showAddStrainModalVue"
      :strain="strain"
    ></AddStrainModalVue>
    <AddStrainIdentificationModalVue
      v-if="showAddStrainIdentificatiònModalVue"
      v-model="showAddStrainIdentificatiònModalVue"
    />
    <HistoryRequest v-if="showHistoryRequest" v-model="showHistoryRequest" />
  </v-card>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
import AddStrainIdentificationModalVue from "./modals/AddStrainIdentificationModal.vue";
import AddStrainModalVue from "./modals/AddStrainModal.vue";
import HistoryRequest from "./modals/HistoryRequest.vue";
//components
export default {
  components: {
    AddStrainModalVue,
    AddStrainIdentificationModalVue,
    HistoryRequest,
  },
  data: () => ({
    menu: null,
    search: null,
    headers: [
      { text: "Microorganismo", value: "identificationName", sortable: false },
      {
        text: "Peticiones",
        align: "center",
        value: "countRequest",
        sortable: false,
      },
      { text: "Tipo", align: "center", value: "moType", sortable: false },
      {
        text: "Almacén",
        align: "center",
        value: "countStock",
        sortable: false,
      },
      {
        text: "Sequence ID",
        align: "center",
        value: "sequenceId",
        sortable: false,
      },
    ],
    bioactives: [],
    page: 1,
    numPages: 1,
    fetchingData: false,
    showAddStrainModalVue: false,
    showAddStrainIdentificatiònModalVue: false,
    showHistoryRequest: false,
    requestItems: [
      {
        text: "Con peticiones",
        value: "REQUEST",
      },
      {
        text: "Sin peticiones",
        value: "NOT_REQUEST",
      },
    ],
    stocktItems: [
      {
        text: "Con stock",
        value: "STOCK",
      },
      {
        text: "Sin stock",
        value: "NOT_STOCK",
      },
    ],
    request: null,
    stock: null,
    filter: null,
    strain: null,
    user: JSON.parse(localStorage.getItem("user")),
  }),
  computed: {
    ...mapState("bioactives", [
      "fetchBoactiveBankList",
      "bioactiveSelected",
      "searchBioactive",
    ]),
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    ...mapActions("bioactives", ["getBioativeBankList"]),
    ...mapMutations("bioactives", [
      "SET_BIOACTIVE_SELECTED",
      "SET_FETCH_BIO_LIST",
      "SET_SEARCH_BIO",
    ]),
    async clearFilter() {
      this.filter = null;
      this.menu = null;
      await this.fetchData();
    },
    async applyFilter() {
      this.filter = {
        stock: this.stock ? this.stock.value : null,
        request: this.request ? this.request.value : null,
      };
      this.menu = null;
      await this.fetchData();
    },

    rowSelect(rowValue) {
      this.bioactives = this.bioactives.map((data) => {
        if (rowValue._id == data._id) {
          data.clicked = true;
        } else {
          data.clicked = false;
        }
        return data;
      });

      this.SET_BIOACTIVE_SELECTED(rowValue);
    },
    row_classes(value) {
      if (value.clicked) {
        return "custom-highlight-row";
      }
    },
    getTypeMO(type) {
      let types = {
        bacteria: "bacteria",
        fungi: "hongo",
      };
      return types[type] ? types[type] : "otro";
    },
    async fetchData() {
      try {
        this.search = this.searchBioactive;
        this.fetchingData = true;
        let response = await this.getBioativeBankList({
          search: this.search,
          page: this.page,
          filter: this.filter,
        });
        if (response) {
          if (!response.error) {
            for (let item of response.strains) {
              item.clicked = false;
            }
            this.bioactives = response.strains;
            this.numPages = response.pages;
            if (this.bioactiveSelected) {
              this.rowSelect(this.bioactiveSelected);
            } else {
              if (this.bioactives.length > 0)
                this.rowSelect(this.bioactives[0]);
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar banco de bioactivos`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar banco de bioactivos`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar banco de bioactivos`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    updateStrain(item) {
      this.strain = item;
      this.showAddStrainModalVue = true;
    },
    addStrain() {
      this.strain = null;
      this.showAddStrainModalVue = true;
    },
  },
  watch: {
    async fetchBoactiveBankList(value) {
      if (value) {
        await this.fetchData();
        this.SET_FETCH_BIO_LIST(false);
      }
    },
    async search(value) {
      this.SET_SEARCH_BIO(value);
      this.SET_BIOACTIVE_SELECTED(null);
      this.page = 1;
      await this.fetchData();
    },
    async page(value) {
      this.SET_BIOACTIVE_SELECTED(null);
      await this.fetchData();
    },
  },
};
</script>
